<template>
    <div class="pm-right" ref="pmRight">
        <canvas id="canvas-arch" v-loading="loading"></canvas>
    </div>
</template>

<script>
import bus from '@/utils/bus.js';
import { getInstance } from '@/utils/planUtil.js';
export default {
    props: ['pmObj', 'treeObj', 'newInfo', 'loading'],
    watch: {
        pmObj(newVal) {
            console.log('pmObj----', newVal)
            this.pmNewObj = { ...newVal };

            this.initCanvas();
        },
        // 选择监测点渲染
        newInfo(newVal) {
            console.log('到这里0----newInfo----------')
            this.carrierInfo = { ...newVal };
            // 锚点回显
            const param = {
                nameParam: 'carrierName',
                statusParam: 'abnormal',
                carrierTypeParam: 'carrierTypeId',
                color: 'orange'
            };

            // this.carrierInfo.carrierPosition.carrierTypeId = this.carrierInfo.typeId;
            const pointList = this.pmNewObj.positionList? [...this.pmNewObj.positionList] : [];


            // if (!this.carrierInfo.carrierPosition) {
            //     const idx = pointList.findIndex(item => item.carrier_id === this.carrierInfo.id);
            // }

            const idx = pointList.findIndex(item => {
                return item.carrierId === this.carrierInfo.id;
            });
            console.log('pointList---', pointList)

            // 设置某一项激活
            this.initPoint(pointList, { active: idx, ...param });
        }
    },
    data() {
        return {
            // canvas对象
            myCanvas: null,
            // canvas 上下文
            canvasCtx: null,
            // 传递的数据
            pmNewObj: {},
            // 借用老版本的类
            planModule: null,
            // 所有的挂载点数据
            pointList: [],
            // 监测点数据
            carrierInfo: '',
            Img: '',
            down: false,
            isMove: false
        };
    },
    mounted() {
        bus.$on('refreshPoint', array => {
            this.planModule.refresh(true);

            this.putPoint(array);
        });
        bus.$on('uploadFile', base64 => {
            this.planModule.setData([], true, true);
            this.initImage(base64);
        });
        bus.$on('updatePmObjPoint', pointList => {
            console.log($t('integration.point_data_arrival_c'), pointList);
            this.pmNewObj.positionList = pointList;
            console.log(' this.pmNewObj.positionList-----=',  this.pmNewObj.positionList)
        });

        this.zoomFns();
        this.delPonits();
        this.isMoveImgFn();
    },
    beforeDestroy() {
        bus.$off('refreshPoint');
        bus.$off('uploadFile');
        bus.$off('zoomFn');
        bus.$off('delPonit');
        bus.$off('isMoveImgFn');
        bus.$off('updatePmObjPoint');
    },
    methods: {
        isMoveImgFn() {
            bus.$on('isMoveImgFn', bool => {
                this.isMove = bool;
                this.clearRect();

                this.initParam(bool);
            });
        },
        initCanvas() {
            this.myCanvas = document.querySelector('#canvas-arch');
            this.canvasCtx = this.myCanvas.getContext('2d');
            this.myCanvas.height = this.$refs.pmRight.offsetHeight - 20;
            this.myCanvas.width = this.$refs.pmRight.offsetWidth - 20;
            this.initParam();
        },
        // 清除画布
        clearRect() {
            this.canvasCtx.clearRect(0, 0, this.myCanvas.width, this.myCanvas.height);
        },
        // 绘制画布
        initParam(bool) {
            const that = this;
            that.$nextTick(function() {
                if (!that.planModule) {
                    that.planModule = getInstance({
                        id: 'canvas-arch',
                        move: bool, // 是否可移动
                        mouseup: function(img, down, drop, data, x, y, pos, e, target) {
                            if (!that.isMove) {
                                if (target) {
                                    bus.$emit('changeCarrier', target);
                                }
                                return;
                            }
                            if (!that.carrierInfo) return that.$message.warning($t('integration.carrier_cannot_be_empty'));
                            let temp = {};

                            if (data) {
                                const idx = data.findIndex(item => item.carrierId === that.carrierInfo.id);
                                temp = { xpos: x, ypos: y };
                                if (idx !== -1) {
                                    data[idx].xpos = x;
                                    data[idx].ypos = y;
                                } else {
                                    temp.xpos = x;
                                    temp.ypos = y;
                                    temp.carrierTypeId = that.carrierInfo.typeId;
                                    temp.carrierName = that.carrierInfo.keycode;
                                    temp.abnormal = that.carrierInfo.abnormal;
                                    temp.abnormal = that.carrierInfo.abnormal;
                                    temp.carrierId = that.carrierInfo.id;
                                    data.push(temp);
                                }
                                console.log('没有到这里吗？？？？、')
                                that.$emit('xyPosFn', temp);
                            }

                            that.planModule.drawImg('carrierName', 'abnormal', 'orange');
                        },
                        mousemove: function(down, drop, data, pos) {}
                    });
                } else that.planModule.move = bool;

                // base64赋值到画布
                this.initImage();
                this.putPoint(this.pmNewObj.positionList);
            });
        },
        putPoint(array) {
            console.log('putPoint---', array)
            this.planModule.setData([], true, true);
            // 如果存在锚点
            if (array && array.length > 0) {
                const param = {
                    nameParam: 'carrierName',
                    statusParam: 'abnormal',
                    carrierTypeParam: 'carrierTypeId',
                    color: 'var(--primary-color)'
                };
                this.initPoint(array, param);
                this.myCanvas.style.cursor = 'pointer';

                // 我就奇了个怪了  在win首次显示必须执行两次才能显示出来？？？
                // this.initPoint(this.pmNewObj.carrierPositionList, param)
                //     .then(res => {
                //         return this.initPoint(this.pmNewObj.carrierPositionList, param);
                //     })
                //     .then(res => {
                //         return this.initPoint(this.pmNewObj.carrierPositionList, param);
                //     });
            }
        },
        windowToCanvas(canvas, x, y) {
            var box = canvas.getBoundingClientRect();
            return {
                x: x - box.left - (box.width - canvas.width) / 2,
                y: y - box.top - (box.height - canvas.height) / 2
            };
        },
        initImage(img) {
            this.planModule.draw([], img || this.pmNewObj.base64Path || '0');
        },
        initPoint(array = '', param) {
            console.log('initPoint---', array)
            // 设备锚点名称字段
            this.planModule.setData([], true, true, param);
            if (!array) return;
            this.planModule.setData(array, true, true, param);

            return new Promise(resolve => {
                setTimeout(() => {
                    this.planModule.setData(array, true, true, param);
                    resolve();
                }, 50);
            });
        },
        // 缩放
        zoomFns() {
            bus.$on('zoomFn', value => {
                if (value < 0) {
                    // 缩小
                    this.planModule.zoomOut(Math.abs(value));
                } else if (value > 0) {
                    // 放大
                    this.planModule.zoomIn(value);
                } else {
                    this.planModule.zoomIn(value);
                }
            });
        },
        // // 移除锚点
        delPonits() {
            bus.$on('delPonit', () => {
                this.planModule.setData([], true, true);
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.pm-right {
    flex: 1;
    padding: 10px;
    box-sizing: border-box;
    color: transparent;
    border: 1px solid #ccc;
    margin-left: 10px;
}
</style>
